import { apiClient } from "@/api/api-client";
import { useAuth } from "@/hooks/use-auth";
import ReactECharts from "echarts-for-react";
import { animate } from "framer-motion";
import { size } from "lodash";
import { s } from "node_modules/framer-motion/dist/types.d-O7VGXDJe";
import { useEffect, useRef, useState } from "react";
import { Bar, BarChart, CartesianGrid, Cell, Label, LabelList, Pie, PieChart, ResponsiveContainer, Sector, Tooltip, XAxis, YAxis } from "recharts";
import { Button } from "../core/buttons/button";

type Item = {
	year: number;
	court_type_name: string;
	total: number;
};

const CasePerYearSummaryChart = ({ hasBranch = false }: { hasBranch: boolean }) => {
	const { user } = useAuth();
	const [data, setData] = useState<Array<Item> | []>([]);
	const [totals, setTotals] = useState<number | null>(null);

	const fetchStatistics = async () => {
		const ids = hasBranch ? user?.branches?.map((branch) => branch?.assignable?.id) : "";
		const response = await apiClient.get(`/backoffice/case-per-year-summary?branch_id=${ids}`);

		console.log(response.data);

		if (response && response.data) {
			setData(response.data.data);
			setTotals(response.data.meta.totals);
		}
	};

	useEffect(() => {
		fetchStatistics();
	}, []);

	return (
		<div className="grid grid-cols-12 w-full gap-4">
			<div className="col-span-12">
				<div className="flex flex-col w-full gap-4">
					<div className="flex flex-col w-full h-auto rounded-md border border-border/50 overflow-hidden">
						<div className="flex flex-row w-full p-3 border-b border-border/50 items-center">
							<div className="flex flex-col w-6/12 text-base font-semibold text-foreground-dark">Cases Per Year Summary</div>
						</div>
						<div className="flex flex-col w-full relative overflow-x-auto">
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
									<tr>
										<th className="px-6 py-3"></th>
										<th className="px-6 py-3 text-right">Total Cases</th>
									</tr>
								</thead>
								<tbody>
									{/* {courts.length && data.length
                    ? courts.map((court, cIndex) => (
                        <tr key={`court-${cIndex}`} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                          <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{court}</td>
                          {years.map((year, yIndex) => {
                            const item = data.find((d) => d.court_type_name === court && d.year === year);
                            return (
                              <td key={`court-${cIndex}-year-${yIndex}`} className="px-6 py-4 text-right">
                                {item ? item.total : 0}
                              </td>
                            );
                          })}
                        </tr>
                      ))
                    : null} */}
									{data.length
										? data.map((item, index) => (
												<tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
													<td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.year}</td>
													<td className="px-6 py-4 text-right">{item.total}</td>
												</tr>
											))
										: null}
								</tbody>
								<tfoot>
									<tr className="font-semibold text-gray-900 dark:text-white">
										<th scope="row" className="px-6 py-3 text-base">
											Total
										</th>
										<th scope="row" className="px-6 py-3 text-base text-right">
											{totals}
										</th>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CasePerYearSummaryChart;
